// extracted by mini-css-extract-plugin
export default {"linkWrapper":"CodeOverrideModal_linkWrapper__0Cs1d","alarmCodesLink":"CodeOverrideModal_alarmCodesLink__MqvgC"};